<!-- <div class="card-button" [hidden]="actionButtons.length == 0" *ngFor="let item of actionButtons">
    {{ item.textBeforeBtn }}
    <button class="btn f-11 position-relative top--3px" [hidden]="item.buttonText==''"
        (click)="onUserAction(item.userAction);" [class]="item.buttonClass" [ngClass]="{'disabled-state': item.disableProperty }" >
        {{ item.buttonText }}
    </button>
</div> -->

@for(item of actionButtons; track item; let i = $index){<div>
    {{ item.textBeforeBtn }}
    @if(!item.hideProperty){<ds-button [buttonInput]="buttonConfig[i]"
        (onClick)="onUserAction(item.userAction)"></ds-button>}
</div>}